module.exports = {
   components: [],
   routes: [],
   sub_routes: [{
         name: "RewardRule",
         path: "configs/reward_rule",
         component: () => import('./reward_rule/reward_rule.vue'),
      },
      {
         name: "PromotionCoupon",
         path: "configs/promotion_coupon",
         component: () => import('./promotion_coupon/promotion_coupon.vue'),
      },
   ]
}